//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- EXPORTAÇÃO DO SERVIÇO LOAD COMPANIES ---------------//
// Responsável por requisitar à API as empresas existentes ao usuário
export default async function createCostService(group_id, value) {
    try {
        console.log(value)
        if (value === null || value === undefined || isNaN(parseFloat(value))) {
            toast.error("Valor inválido");
            return false;
        }
        const response = await api.post("/gastos-grupo", { grupo_id: group_id, valor: parseFloat(value) });
        toast.success("Gasto salvo com sucesso")
        return true;
    } catch (error) {
        toast.error("Erro ao salvar gasto");
        return false;
    }
}